import { PhoneSliceType, WebSliceType } from "./type.ts";

export const RoleStatus = {
  Inactive: "I",
  Active: "A,D",
  Draft: "D",
  All: "",
} as const;

export const initialStatePhone: PhoneSliceType = {
  data: { all: [], active: [], inactive: [] },
  status: RoleStatus.Active,
  pageSize: 5,
  currentPage: 1,
  sortBy: "",
  search: "",
  subcompany_id: null,
  loading: false,
  error: false,
  count: 0,
  next: null,
  prev: null,
};

export const initialStateWeb: WebSliceType = {
  data: { all: [], active: [], inactive: [], draft: [] },
  status: RoleStatus.Active,
  pageSize: 5,
  currentPage: 1,
  sortBy: "",
  search: "",
  subcompany_id: null,
  loading: false,
  error: false,
  count: 0,
  next: null,
  prev: null,
};
